import { useEffect, useReducer, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../components/Layout";
import { clearFilter } from "../features/filter/filterSlice";
import { getJob } from "../features/job/jobAPI";
import { createJob, updateJob } from "../features/job/jobSlice";

export default function CreateJob() {
  const [editMode, setEditMode] = useState(false)
  const dispatch = useDispatch();
  const { jobId } = useParams()
  const navigate = useNavigate()

  const initialData = {
    "title": "",
    "type": "",
    "salary": "",
    "deadline": ""
  };


  const [data, setData] = useReducer((prev, next) => {
    return { ...prev, ...next };
  }, initialData)

  const findJob = async (id) => {
    if (!id) {
      setData({ ...initialData })
      setEditMode(false)
      return;
    }
    try {
      const job = await getJob(id)
      if (job && job.id) {
        setData({ ...job })
        setEditMode(true)
      }
    } catch (error) {
      setData({ ...initialData })
    }
  }

  useEffect(() => {
    findJob(jobId)
  }, [jobId])


  const handleSubmit = (e) => {
    e.preventDefault();

    if (data && validateData(data)) {
      try {
        if (jobId) {
          dispatch(updateJob({ id: jobId, data }))
        } else {
          dispatch(createJob(data))
        }
        dispatch(clearFilter())
        navigate('/')
      } catch (error) {
        console.error('something went wrong')
      }
    }
  }

  const validateData = (job) => {
    return job && Object.entries(job).length &&
      job.title && job.type && job.salary && job.deadline
  }

  return (
    <Layout>
      <h1 className="mb-10 text-center lws-section-title">{editMode ? 'Edit Job' : 'Add New Job'}</h1>

      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="fieldContainer">
            <label htmlFor="lws-JobTitle" className="text-sm font-medium text-slate-300">Job Title</label>
            <select value={data.title} onChange={(e) => setData({ title: e.target.value })} id="lws-JobTitle" name="lwsJobTitle" required>
              <option value="" hidden >Select Job</option>
              <option>Software Engineer</option>
              <option>Software Developer</option>
              <option>Full Stack Developer</option>
              <option>MERN Stack Developer</option>
              <option>DevOps Engineer</option>
              <option>QA Engineer</option>
              <option>Product Manager</option>
              <option>Social Media Manager</option>
              <option>Senior Executive</option>
              <option>Junior Executive</option>
              <option>Android App Developer</option>
              <option>IOS App Developer</option>
              <option>Frontend Developer</option>
              <option>Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select value={data.type} onChange={(e) => setData({ type: e.target.value })} id="lws-JobType" name="lwsJobType" required>
              <option value="" hidden >Select Job Type</option>
              <option>Full Time</option>
              <option>Internship</option>
              <option>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input value={data.salary} onChange={e => setData({ salary: e.target.value })} type="number" name="lwsJobSalary" id="lws-JobSalary" required className="!rounded-l-none !border-0"
                placeholder="20,00,000" />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input value={data.deadline} onChange={e => setData({ deadline: e.target.value })} type="date" name="lwsJobDeadline" id="lws-JobDeadline" required />
          </div>

          <div className="text-right">
            <button type="submit" id="lws-submit" className="cursor-pointer btn btn-primary w-fit">
              {editMode ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  )
}